import styles from './occasions_grid.module.scss';
import React from 'react';

interface OwnProps {
    children: React.ReactNode;
}

export function OccasionsGrid({children}: OwnProps) {
    return <div className={styles.occasions_grid}>{children}</div>;
}
